import {ImmutableArray} from "./array";

export {ImmutableArray}

export const Immutable = {
    Array: ImmutableArray
}
